import { useStore } from 'vuex';
import { createFingerPrint } from '@/utils/fingerprintjs2';
import { filterWord } from '@/api/common/index';
import { generateUniqueId } from '@/utils/index';
export default (() => {
  const macTotal = 20000;
  const userTotal = 20000;
  const remainderNum = ref(0);
  const store = useStore();
  const token = computed(() => store.state.userInfo.token);
  const uuid = computed(() => store.state.userInfo.uuid);
  const macId = computed(() => store.state.userInfo.macId);
  const wwid = computed(() => store.state.userInfo.unionNo);
  const getMacId = cb => {
    createFingerPrint(id => {
      console.log('setMacId', id);
      store.commit('userInfo/setMacId', id);
      cb && cb(id);
    });
  };
  const getMessageTotalInfo = async (word, cb) => {
    // const res: any = await getMessageTotal({ macId: id })
    const res = await filterWord({
      text: encodeURIComponent(word)
    });
    cb && cb(res.status);
    // remainderNum.value = token.value
    //   ? userTotal - res.userTotal
    //   : macTotal - res.macTotal
    // cb && cb(remainderNum.value)
  };

  const setUniqueId = (usedUuid = '') => {
    const uuid = usedUuid || generateUniqueId();
    store.commit('userInfo/setUuid', uuid);
  };
  return {
    token,
    macId,
    getMacId,
    getMessageTotalInfo,
    uuid,
    setUniqueId,
    wwid
  };
});